import React from "react";
import { Tooltip } from "antd";
import { HTMLTooltipContainer, Wrapper } from "./style";
import { ReactComponent as InfoIcon } from "../../../../../assets/icons/info.svg";
import { documentTooltipInfo } from "../../../../../utils/const";

const UploadHeader = ({ label, title }: { label: string; title: string }) => {
  const convertedHtmlEntities = () => {
    return <HTMLTooltipContainer dangerouslySetInnerHTML={{ __html: documentTooltipInfo[label] || label }} />;
  };
  return (
    <Wrapper>
      <p>
        <span>{title}</span>

        <span>
          <Tooltip title={convertedHtmlEntities}>
            <InfoIcon />
          </Tooltip>
        </span>
      </p>
    </Wrapper>
  );
};

export default UploadHeader;
